// extracted by mini-css-extract-plugin
module.exports = {"coursePublicationStatusContainer":"CourseStatusCount_coursePublicationStatusContainer_2D3Sc","coursePublicationStatusList":"CourseStatusCount_coursePublicationStatusList_289Vk"};